module.exports = __webpack_public_path__ + "static/media/card.79f0d5b1.svg";